const SCROLL_THRESHOLD = 5;

export function hasReachedBottom(el) {
  if (!el) return false;
  return el.scrollTop + el.clientHeight >= el.scrollHeight - SCROLL_THRESHOLD;
}

export function isContentScrollable(el) {
  if (!el) return false;
  return el.scrollHeight > el.clientHeight;
}

export function checkScrolledToBottom(el, alreadyScrolled) {
  if (alreadyScrolled) return true;
  return hasReachedBottom(el);
}

/**
 * Determines whether the "Confirm Eligibility" button should be enabled
 * based on the new-let question state.
 */
export function isNewLetConfirmEnabled(newLetState) {
  if (!newLetState.answered) return false;
  if (newLetState.value === false && !newLetState.checkboxTicked) return false;
  return true;
}
